
/*
 *
 * Date: 2025
 * Description: Payment container to manage payments
 * Author: Philippe Leroux @SKITSC
 *
 */

//Modules
import { Box, Grid , Typography , Button, Paper, IconButton } from "@mui/material"

//Interfaces
import { i_payments } from "../../interfaces/items.interface"
import { i_payment_container } from "../../interfaces/display.interfaces"

//Utils
import { timestampToDate } from "../../utils/utility"

//Icons
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import UpdateIcon from '@mui/icons-material/Update';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const PaymentContainer = ( props : i_payment_container ) => {

    const renderTotal = (): string => {
        const total = props.payments.reduce((sum, payment) => {
            return sum + parseFloat(payment.amount || "0");
        }, 0);
        return total.toFixed(2);
    };
    const countToPaid = (): string => {
        const total = props.history[0].order.reduce((sum, item) => {
            return sum + parseFloat(item.price || "0");
        }, 0);
        return total.toFixed(2);
    }
    const renderBalance = (): string => {
        if(props.payments === undefined ) return countToPaid();
        var totalBalance = Number(countToPaid()) - Number(renderTotal());
        return totalBalance.toFixed(2);
    }
    const renderColor = () => {
        if(Number(renderBalance()) === 0){
            return 'lime'
        } else if(Number(renderBalance()) > 0){
            return'red'
        } else {
            return 'purple'
        }
    }
    const subTitle = { fontWeight : '500' , fontSize : 16 , marginLeft : '6px' }    
    const headerTitle = { fontWeight : '700' , textDecoration : 'underline' , fontSize : 20 }
    return (
        <Paper sx={{ padding : 2}}>
            <Grid container>
                <Grid size={{xs : 12}} sx={{ marginBottom : '1vh'}}>
                    <IconButton onClick={() => props.goBack()}><ArrowBackIcon /></IconButton>
                </Grid>
                <Grid size={{xs : 9}}>
                    <Typography variant="h5">Payment details</Typography>
                </Grid>
                <Grid size={{xs : 3}}>
                    <Button variant="contained" onClick={() => props.callback('add' , -1)}>Add payment</Button>
                </Grid>
                <Grid size={12} sx={{ marginBottom : '1vh'}}>
                    <Paper elevation={4} sx={{ marginTop : '1vh'}}>
                        <Grid p={2} container>
                            <Grid size={6}>
                                <Box sx={{ display : 'flex' , alignItems : 'center'}}>Total payments: 
                                    <Typography sx={subTitle}>{props.payments === undefined? 0 : props.payments.length}</Typography>
                                </Box>
                            </Grid>
                            <Grid size={6}>
                                <Box sx={{ display : 'flex' , alignItems : 'center'}}>Total paid: 
                                    <Typography sx={subTitle}>{props.payments === undefined ? 0 : renderTotal()}$</Typography>
                                </Box>
                            </Grid>
                            <Grid size={6}>
                                <Box sx={{ display : 'flex' , alignItems : 'center'}}>Total ordered: 
                                    <Typography sx={subTitle}>{props.history[0] !== undefined ? countToPaid() : 0 }$</Typography>
                                </Box>
                            </Grid>
                            <Grid size={6}>
                                <Box sx={{ display : 'flex' , alignItems : 'center'}}>Total balance: 
                                    <Typography sx={[subTitle , { color : renderColor() , fontSize : 18 , fontWeight : 700}]}>{ renderBalance()} $</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid size={{xs : 12}}>
                    <Paper >
                            {props.payments === undefined || props.payments.length === 0  ?
                            
                                <Typography variant="body2">No payments found</Typography> :
                                <Box>
                                    <Grid p={2} container>
                                        <Grid size={3}>
                                            <Typography variant="subtitle2" sx={ headerTitle}>Amount</Typography>
                                        </Grid>
                                        <Grid size={3}>
                                            <Typography variant="subtitle2" sx={ headerTitle}>Type</Typography>
                                        </Grid>
                                        <Grid size={3}>
                                            <Typography variant="subtitle2" sx={ headerTitle}>Date</Typography>
                                        </Grid>
                                        <Grid size={3}>
                                            <Typography variant="subtitle2" sx={ headerTitle}>Actions</Typography>
                                        </Grid>
                                    </Grid>
                                        {props.payments.map((payment : i_payments, index : number) => (
                                            <Grid p={1} container key={index} sx={{ marginTop : '10px' , borderBottom : '1px solid black' , alignItems : 'center' }}>
                                                <Grid size={3}>
                                                    <Typography sx={subTitle} variant="body2">{payment.amount}$</Typography>
                                                </Grid>
                                                <Grid size={3}>
                                                    <Typography sx={subTitle} variant="body2">{payment.type}</Typography>
                                                </Grid>
                                                <Grid size={3}>
                                                    <Typography sx={subTitle} variant="body2">{timestampToDate(payment.timestamp , 'long')}</Typography>
                                                </Grid>
                                                <Grid size={3}>
                                                    <IconButton onClick={() => props.callback('update', index)}><UpdateIcon/></IconButton>
                                                    <IconButton sx={{ color : 'red'}} onClick={() => props.callback('delete', index)}><DeleteForeverIcon /></IconButton>
                                                </Grid>
                                            </Grid>
                                        ))}
                                </Box>
                        }
                    </Paper>
                </Grid>
            </Grid>
        </Paper>
    )
}


export default PaymentContainer